(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yg-image"] && !Shopify.designMode) return;
  try {
    class YGImage extends YGImageLazyLoader {
    constructor() {
      super();
    }
    connectedCallback() {
      this.loaderImg();
    }
    get images() {
      return this.querySelectorAll('img[data-src]');
    }

    loaderImg() {
      // 这里放置自定义逻辑
      this.images.forEach((img) => {
        // 安全检查，确保 YGUtils 已加载
        if (this.getLazyLoader) {
          this.getLazyLoader().observe(img);
        } else {
          console.warn('YGUtils 未加载，使用备用图片加载方式');
          // 备用方案：直接设置图片源
          if (img.getAttribute('data-src')) {
            img.src = img.getAttribute('data-src');
            img.removeAttribute('data-src');
          }
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!window.customElements.get('yg-image')) {
      window.customElements.define('yg-image', YGImage);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
